import { TableField } from "../../table-field";

const idAnexo: TableField = {
    key: "IdAnexo",
    label: "ID",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const nomeAnexo: TableField = {
    key: "NomeAnexo",
    label: "Nome",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const tipoAnexo: TableField = {
    key: "IdTipoAnexoNavigation.DsTipoAnexo",
    label: "Tipo",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const detalheAnexo: TableField = {
    key: "DsDetalhes",
    label: "Detalhe",
    tdClass: ["quebrarPorPalavraHard, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const actions: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}

export const fieldsAnexos: TableField[] = [
    idAnexo,
    nomeAnexo,
    tipoAnexo,
    actions,
]

export const fieldsAnexosConcurso: TableField[] = [
    nomeAnexo,
    tipoAnexo,
    detalheAnexo,
    actions,
]